import gsap from 'gsap';

export const heroContentAnimation = () => {
	const heroContent = document.querySelector('.hero-content');

	if (!heroContent) return;

	const delay = parseFloat(heroContent.getAttribute('data-delay')) || 0.7;

	const heroHeading = document.querySelector('.hero-heading');
	if (heroHeading) {
		gsap.fromTo(
			heroHeading,
			{ opacity: 0, y: '30%' },
			{
				opacity: 1,
				y: 0,
				delay: delay,
				duration: 0.62,
				ease: 'headingEasing',
			}
		);
	}

	const heroDescription = document.querySelector('.hero-description');
	if (heroDescription) {
		gsap.fromTo(
			heroDescription,
			{ opacity: 0, y: '20%' },
			{
				opacity: 1,
				y: 0,
				delay: delay + 0.2,
				duration: 0.714,
				ease: 'smoothEasing',
			}
		);
	}

	const heroButton = document.querySelectorAll('.hero-button');
	if (heroButton) {
		heroButton.forEach((button, index) => {
			gsap.fromTo(
				button,
				{ opacity: 0, y: 24 },
				{
					opacity: 1,
					y: 0,
					delay: delay + 0.45 + index * 0.1,
					duration: 0.6,
					ease: 'buttonEasing',
				}
			);
		});
	}
};

export const heroImageAnimation = () => {
	const heroImageLeft = document.querySelector('.hero-image-left');
	const heroImageRight = document.querySelector('.hero-image-right');

	if (heroImageLeft) {
		gsap.fromTo(
			heroImageLeft,
			{ rotate: -10 },
			{
				rotate: 0,
				delay: 0.5,
				duration: 3,
				ease: 'power2.out',
				scrollTrigger: {
					trigger: heroImageLeft,
					start: 'top 80%',
					end: 'bottom 20%',
					toggleActions: 'play none none reverse',
				},
			}
		);
	}

	if (heroImageRight) {
		gsap.to(heroImageRight, {
			rotate: -10,
			x: -34,
			y: 0,
			delay: 0.35,
			duration: 1.5,
			ease: 'imageEasing',
			scrollTrigger: {
				trigger: heroImageRight,
				start: 'top 80%',
				end: 'bottom 20%',
				toggleActions: 'play none none reverse',
			},
		});
	}
};

export const parallaxBg = () => {
	const bg = document.querySelectorAll('.parallax-bg');

	if (!bg) return;

	bg.forEach((element) => {
		gsap.to(element, {
			y: '15%',
			ease: 'linear',
			scrollTrigger: {
				trigger: element,
				start: 'top bottom',
				end: 'bottom top',
				scrub: true,
			},
		});
	});

	const bgReverse = gsap.utils.toArray('.parallax-bg-reverse');

	bgReverse.forEach((element) => {
		gsap.to(element, {
			y: '15%',
			ease: 'none',
			scrollTrigger: {
				trigger: element,
				start: 'top bottom',
				end: 'bottom top',
				scrub: true,
			},
		});
	});
};

export const heroSliderAnimate = () => {
	const sliderMask = document.querySelector('#sliderMask');

	if (!sliderMask) return;

	const circle = sliderMask.querySelector('#circle');
	const square1 = sliderMask.querySelector('#square1');
	const square2 = sliderMask.querySelector('#square2');

	if (!circle || !square1 || !square2) return;

	const tl = gsap.timeline({});

	tl.to(circle, {
		x: 508,
		y: 83,
		duration: 1.6,
		ease: 'smoothEasing',
	});

	const tl2 = gsap.timeline({});

	tl2.to(square1, {
		rotate: -98,
		x: -37,
		y: 41,
		duration: 1.2,
		ease: 'smoothEasing',
	});

	const tl3 = gsap.timeline({});

	tl3.to(square2, {
		x: -141,
		y: -116,
		rotate: -48,
		scale: 1.1,
		duration: 1.2,
		ease: 'smoothEasing',
	});
};
